angular.module('impactx.b2b').controller('EditCustomerCompanyCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    'dataGen',
    'ToastService',
    EditCustomerCompanyCtrl
]);

function EditCustomerCompanyCtrl($scope, $mdDialog, TranslationService, dataGen, ToastService) {
    var ctrl = this;
    ctrl.companyInputDataArray = [{field: "userId", value: ctrl.userId}, {field: "id", value: ctrl.id}];

    dataGen.getData($scope, {id: ctrl.id, userId: ctrl.userId}, "/b2b/customercompany/view").then(function () {
        $scope.trns.cancel = TranslationService.get('abort');
        $scope.trns.save = TranslationService.get('save');
    });

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.save = function () {
        return dataGen.postAsForm({}, {data: $scope.data}, "/b2b/customercompany/save").then(function() {
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    }
}